<template>
  <v-card
    width="550px"
    class="mb-2"
  >
    <v-card-text>
      <v-data-table
        dense
        :headers="headers"
        :items="selectedPointLayerPoints"
        :point-layer-types="pointLayerTypes"
        sort-by="data"
        :sort-desc="true"
        height="250px"
        fixed-header
        :items-per-page="5"
        :footer-props="footerProps"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <template v-for="item in items">
              <v-hover
                :key="item.key"
                v-slot:default="{ hover }"
              >
                <tr>
                  <td>{{ item.data }}</td>
                  <td>{{ item.layerType.description }}</td>
                  <td>{{ item.stationCount }}</td>
                  <td>
                    <v-btn
                      icon
                      :color="hover ? item.layerType.color : ''"
                      @click="fitViewToPointOnMap(item)"
                    >
                      <v-icon>fa-map-pin</v-icon>
                    </v-btn>
                  </td>
                  <template
                    v-if="
                      hover
                        ? setCurrentHoverItem(item)
                        : unsetCurrentHoverItem()
                    "
                  />
                </tr>
              </v-hover>
            </template>
          </tbody>
        </template>
      </v-data-table>
    </v-card-text>
    <v-speed-dial
      v-model="exportSpeedDial"
      bottom
      left
      transition="slide-y-reverse-transition"
      open-on-hover
      absolute
    >
      <template v-slot:activator>
        <v-btn
          v-model="exportSpeedDial"
          fab
          small
          icon
          color="secondary"
        >
          <v-icon v-if="exportSpeedDial">
            fa-times
          </v-icon>
          <v-icon v-else>
            fa-file-export
          </v-icon>
        </v-btn>
      </template>
      <v-btn
        color="secondary"
        @click="exportTable('csv')"
      >
        csv
      </v-btn>
      <v-btn
        color="secondary"
        @click="exportTable('xlsx')"
      >
        xlsx
      </v-btn>
    </v-speed-dial>
  </v-card>
</template>
<script>
import { parse } from "json2csv";
import { saveAs } from "file-saver";
import XLSX from "xlsx";
import slugify from "slugify";

import { toLonLat } from "ol/proj";
import { toStringHDMS } from "ol/coordinate";

export default {
  props: { visiblePointLayers: Array, pointLayerTypes: Array },
  data() {
    return {
      headers: [
        { text: "kWh", value: "data" },
        { text: "Ebene", value: "layerType.description" },
        { text: "Anzahl Punkte", value: "stationCount" },
        { text: "Gehe zu Station", sortable: false }
      ],
      footerProps: {
        "items-per-page-options": [5, 10, 25, 50],
        "items-per-page-text": "Zeilen pro Seite"
      },
      currentHoverItem: null,
      exportSpeedDial: false
    };
  },
  computed: {
    selectedPointLayerPoints() {
      var selectedPointLayerPoints = [];
      let key = 0;
      for (var layer of this.visiblePointLayers) {
        var layerType = this.pointLayerTypes.find(
          layerType => layerType.layertypesId == layer.get("layerTypeId")
        );
        layer.getSource().forEachFeature(feature => {
          selectedPointLayerPoints.push({
            key: key,
            layerType: layerType,
            data:
              typeof feature.get("data") == "number"
                ? Math.round(feature.get("data"))
                : "",
            stationCount: feature.get("station_count"),
            feature: feature
          });
          key++;
        });
      }
      return selectedPointLayerPoints;
    }
  },
  watch: {
    // emit events to highlight / unhighlight single points on map on table row hover
    currentHoverItem(newVal, oldVal) {
      if (newVal === null) {
        window.EventBus.$emit("unhighlightPointOnMap", oldVal);
      } else if (oldVal === null) {
        window.EventBus.$emit("highlightPointOnMap", newVal);
      }
    }
  },
  methods: {
    setCurrentHoverItem(item) {
      this.currentHoverItem = item;
      return true;
    },
    unsetCurrentHoverItem() {
      this.currentHoverItem = null;
      return false;
    },
    // emit event to select and center/zoom map view onto single point
    fitViewToPointOnMap(item) {
      window.EventBus.$emit("selectPointAndFitViewOnMap", item);
    },
    // export table to downloadable file
    exportTable(fileFormat) {
      // construct filename in format ags_update-description_update-date_year__today
      let fileName = slugify(
        `${this.$store.state.selectedAgs.name}` +
          `_${this.$store.state.selectedUpdate.description}` +
          `-${this.$store.state.selectedUpdate.dateOfUpdate.slice(0, 10)}` +
          `_${this.$store.getters.selectedYear}` +
          `__${new Date().toISOString().slice(0, 10)}`
      );
      // transform point data into flat json format
      let exportJson = this.selectedPointLayerPoints.map(point => {
        return {
          kWh: point.data,
          Ebene: point.layerType.description,
          "Anzahl Punkte": point.stationCount,
          Koordinaten: toStringHDMS(
            toLonLat(point.feature.getGeometry().flatCoordinates)
          )
        };
      });
      if (fileFormat == "csv") {
        // export as csv
        let csvFile = new Blob([parse(exportJson)], {
          type: "text/plain;charset=utf-8"
        });
        saveAs(csvFile, `${fileName}.csv`);
      } else {
        // export as xlsx
        let xlsxWorkbook = XLSX.utils.book_new();
        let xlsxSheet = XLSX.utils.json_to_sheet(exportJson);
        XLSX.utils.book_append_sheet(xlsxWorkbook, xlsxSheet, "data");
        XLSX.writeFile(xlsxWorkbook, `${fileName}.xlsx`);
      }
    }
  }
};
</script>
